<template>
  <div>
    <b-container>
      <b-row>
        <b-col>
          <b-table
            striped
            hover
            :items="dataTable.items"
            :fields="dataTable.fields"
            :per-page="perPage"
            :current-page="currentPage"
            @filtered="onFiltered"
          >
          </b-table>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            aria-controls="my-table"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        currentPage: 1,
        perPage: 5,
        totalRows: 0,
        filter: '',
      }
    },
    props: ['dataTable', 'options'],
    methods: {
      onFiltered(filteredItems) {
        // Update the total rows to match the number of filtered items
        this.totalRows = filteredItems.length
        this.currentPage = 1 // Reset to the first page
      },
    },
    mounted() {
      this.totalRows = this.dataTable.items.length
      if (this.options?.perPage) {
        this.perPage = this.options.perPage
      }
    },
  }
</script>

<style scoped></style>
